import React from 'react';
import { getValueOrDefault } from '@utils/commonUtils';
import './DetailRow.css';

interface DetailRowProps {
  label: string;
  value: any;
}

const DetailRow: React.FC<DetailRowProps> = ({ label, value }) => {
  return (
    <div className="common-detail-row">
      <label className="common-detail-row-label">{label}</label>
      <div className="common-detail-row-value">{getValueOrDefault(value)}</div>
    </div>
  );
};

export default DetailRow;